export const OP_MAP = (t) => ({ ">=": t("Väh."), "<": t("Alle") })
export const UNIT_MAP = (t) => ({ "wk": t("viikkoa"), "h": t("viikkotuntia"), "pl": t("pelaajaa") })

export const formatRuleCriteria = ({ t, rule })  => {
	const { value, criteriaStr } = rule

	return criteriaStr?.replace("{n}", value) ?? ""
}